import React from "react";
import { determinePagePlatform } from "../nav-util/ga4";
var priceLeft = [{
  label: "60萬以下",
  value: "0,60"
}, {
  label: "80-120萬",
  value: "80,120"
}, {
  label: "180-300萬",
  value: "180,300"
}];
var priceRight = [{
  label: "60-80萬",
  value: "60,80"
}, {
  label: "120-180萬",
  value: "120,180"
}, {
  label: "300萬以上",
  value: "300,99999"
}];
var newCar = [{
  name: "一鍵詢價",
  link: "buyCar"
}, {
  name: "精選業代",
  link: "agent/business"
}, {
  name: "購車菜單",
  link: "buycar/menu"
}, {
  name: "查成交價",
  link: "ask/price?source=全站導航-查成交價&kindType=checkPrice"
}];
var UsedcarPopover = function UsedcarPopover(_ref) {
  var auto = _ref.auto,
    dataSource = _ref.dataSource,
    ga = _ref.ga;
  var list = dataSource.list,
    unfinishedUsers = dataSource.unfinishedUsers;
  var setUrlFormat = function setUrlFormat(str) {
    if (!str) return;
    var val = str.toLowerCase();
    val = val.replace(/\s+/g, "-");
    val = val.replace(/\./g, "-.-");
    val = val.replace(/&amp;/g, "&");
    return val;
  };
  var formatThousend = function formatThousend(num) {
    if (Number(num) > 10000) {
      return "".concat((Number(num) / 10000).toFixed(1), "\u842C");
    }
    var reg = /\d{1,3}(?=(\d{3})+$)/g;
    return (num + "").replace(reg, "$&,");
  };
  return /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-left border-right'
  }, /*#__PURE__*/React.createElement("h3", {
    className: 'tc-top-nav-popover-title'
  }, "\u8CB7\u8ECA\u5DE5\u5177"), /*#__PURE__*/React.createElement("ul", {
    id: "NavCarTool-".concat(determinePagePlatform)
  }, newCar.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item.name
    }, /*#__PURE__*/React.createElement("a", {
      href: "".concat(auto, "/").concat(item.link),
      target: '_blank',
      rel: 'noreferrer'
    }, item.name));
  }))), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-middle'
  }, /*#__PURE__*/React.createElement("h3", {
    className: 'tc-top-nav-popover-title'
  }, "\u689D\u4EF6\u627E\u8ECA"), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-middle-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-newcar-section'
  }, /*#__PURE__*/React.createElement("p", {
    className: 'tc-top-nav-popover-newcar-section-title',
    style: {
      backgroundColor: "#3264FF"
    }
  }, "\u71B1\u9580\u5EE0\u724C"), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-newcar-section-list'
  }, /*#__PURE__*/React.createElement("ul", {
    id: "NavHotBrandList-".concat(determinePagePlatform),
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 110px)"
    }
  }, list.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      className: 'tc-top-nav-popover-newcar-section-li',
      key: item.brandId
    }, /*#__PURE__*/React.createElement("a", {
      href: "".concat(auto, "/Models/").concat(setUrlFormat(item.brandName)),
      target: '_blank',
      onClick: function onClick() {},
      rel: 'noreferrer'
    }, item.brandName));
  })))), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-newcar-section second'
  }, /*#__PURE__*/React.createElement("p", {
    className: 'tc-top-nav-popover-newcar-section-title',
    style: {
      backgroundColor: "#3264FF"
    }
  }, "\u50F9\u683C"), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-newcar-section-list'
  }, /*#__PURE__*/React.createElement("ul", {
    id: "NavPriceList-".concat(determinePagePlatform)
  }, priceLeft.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      className: 'tc-top-nav-popover-newcar-section-li',
      key: item.value
    }, /*#__PURE__*/React.createElement("a", {
      href: "".concat(auto, "/Models/search/x-").concat(item.value, "-x-x-x-x-x-x-x-x-x-x"),
      onClick: function onClick() {
        ga(["导航", "新车", "价格"]);
      },
      target: '_blank',
      rel: 'noreferrer'
    }, item.label));
  })), /*#__PURE__*/React.createElement("ul", null, priceRight.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      className: 'tc-top-nav-popover-newcar-section-li',
      key: item.value
    }, /*#__PURE__*/React.createElement("a", {
      href: "".concat(auto, "/Models/search/x-").concat(item.value, "-x-x-x-x-x-x-x-x-x-x"),
      onClick: function onClick() {
        ga(["导航", "新车", "价格"]);
      },
      target: '_blank',
      rel: 'noreferrer'
    }, item.label));
  })))))), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-right'
  }, /*#__PURE__*/React.createElement("h3", {
    className: 'tc-top-nav-popover-title'
  }, "\u696D\u4EE3\u7372\u5BA2"), /*#__PURE__*/React.createElement("p", {
    className: 'tc-top-nav-popover-right-content',
    style: {
      width: 380,
      color: "#333"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: 'newcar-highlight'
  }, formatThousend(unfinishedUsers)), "\u4F4D\u8CB7\u5BB6\u7B49\u5F85\u670D\u52D9\u4E2D\uFF0C\u6700\u5FEB", /*#__PURE__*/React.createElement("span", {
    className: 'newcar-highlight'
  }, "\u7576\u5929"), "\u5C31\u80FD\u6210\u4EA4\uFF01"), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-right-footer'
  }, /*#__PURE__*/React.createElement("a", {
    className: 'tc-top-nav-popover-right-link newcar',
    href: "".concat(auto, "/agent/investment?globalSource=navCar"),
    onClick: function onClick() {
      ga(["导航", "中古车", "搶先獲客"]);
    },
    id: "NavCustomersFirst-".concat(determinePagePlatform),
    target: '_blank',
    rel: 'noreferrer'
  }, "\u6436\u5148\u7372\u5BA2"))));
};
export default UsedcarPopover;